import React from "react";
import Tooltip from "@reach/tooltip";
import "@reach/tooltip/styles.css";

const InfoButton = () => {
  return (
    <svg  width="18" height="17" viewBox="0 0 512 512">
      <path d="M224 152c0-13.2 10.8-24 24-24h16c13.2 0 24 10.8 24 24v16c0 13.2-10.8 24-24 24h-16c-13.2 0-24-10.8-24-24v-16z"></path>
      <path  d="M320 384h-128v-32h32v-96h-32v-32h96v128h32z"></path>
      <path d="M256 0c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256zM256 464c-114.875 0-208-93.125-208-208s93.125-208 208-208 208 93.125 208 208-93.125 208-208 208z"></path>
    </svg>
  );
}



export default function Questionmark (props) {
  return  (
    <Tooltip label={props.value} >
      <span className="questionmark"><InfoButton /></span>
    </Tooltip>
  )
}
